import React from 'react';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { handleLogout } from '../utils/loginFunctions';

/**
 * Renders a button which, when selected, will redirect the page to the logout prompt
 */
export function SignOutButton() {
  const { instance } = useMsal();
  const [t] = useTranslation();
  return (
    <button
      className="ml-auto"
      onClick={() => {
        handleLogout(instance);
      }}
    >
      {t('common.header.menu.logout')}
    </button>
  );
}
